export default __webpack_public_path__ + "static/media/tl7.26ee89aa.webp";